import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// // // LIST ALL Sponsors
export const sponsorsList = (params = '') => Http.get(`/showcase-sponsors${serialize(params)}`)

export const sponsorCreate = (params = '') => Http.post('/showcase-sponsors', params)
export const sponsorByID = (params = '') => Http.get(`/showcase-sponsors/${params}?include=showcase,partner`)
export const sponsorUpdate = (params = '') => Http.put(`/showcase-sponsors/${params.id}`, params)
export const sponsorDestroy = (params = '') => Http.delete(`/showcase-sponsors/${params.id}`)
